module.exports = __webpack_public_path__ + "static/media/brycen7.f0f2e9ab.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen7.gif
// module id = 152
// module chunks = 0